// This file was automatically generated and should not be edited.;
import type { SVGProps } from 'react';
import { Ref, forwardRef } from 'react';
const SvgLevelMid = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      d="M1.667 12.668a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v4.667a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1zM7.5 7.668a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v9.667a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1z"
    />
    <path
      stroke="currentColor"
      d="M13.833 2.668a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v14.667a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5z"
    />
  </svg>
);
export const LevelMidIcon = forwardRef(SvgLevelMid);
